import { h, createContext, ComponentChildren } from "preact";
import { useState, useContext, useRef } from "preact/hooks";

interface SectionObserverContext {
    sectionObserver: IntersectionObserver | null;
    initSectionObserver: (observer: IntersectionObserver) => void;
    disconnectSectionObserver: () => void;
}

const SectionObserverContext = createContext<SectionObserverContext | null>(null);

function SectionObserverProvider<P extends { children?: ComponentChildren; }>(props: P) {
    const [sectionObserver, setSectionObserver] = useState<IntersectionObserver | null>(null);
    const sectionObserverRef = useRef<IntersectionObserver | null>(null);

    function initSectionObserver(observer: IntersectionObserver) {
        setSectionObserver(observer);
        sectionObserverRef.current = observer;
    }

    function disconnectSectionObserver() {
        if (sectionObserverRef.current) {
            sectionObserverRef.current.disconnect();
        }
    }

    return (
        <SectionObserverContext.Provider value={{
            sectionObserver,
            initSectionObserver,
            disconnectSectionObserver
        }}>
            {props.children}
        </SectionObserverContext.Provider>
    );
}

const useSectionObserver = () => useContext(SectionObserverContext);

export { SectionObserverContext, SectionObserverProvider, useSectionObserver };
